export enum MenusType {
  TAG = 'TAG',
  OWNER = 'OWNER',
  PAGE = 'PAGE',
  EXTERNAL_LINK = 'EXTERNAL_LINK',
}
